module.exports = __webpack_public_path__ + "icon-pando-profile-on.e62d884b316631d8ef16.svg";